export default "__VITE_ASSET__DdNEisoN__"